export default __webpack_public_path__ + "static/media/element_spec_62.db337fab.webp";